module.exports = __webpack_public_path__ + "img/招标信息.f66d6487.jpg";